import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Listing } from 'ha/services/apiV2/types/Listing';
import { Currency } from 'ha/constants/Currencies';

interface Query {
  userId: number;
  expand?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  query?: string;
  state?: string;
  withCroppedPhotos?: boolean;
  withHidden?: boolean;
  withPhotos?: string;
  minPrice?: number;
  maxPrice?: number;
  currency?: Currency;
  from?: string;
  to?: string;
}

export interface ListingsResponse {
  count: number;
  listings: Listing[];
}

export type GetListingsCall = (
  data: Query,
) => Promise<{ data: ListingsResponse }>;

export default (makeCall: MakeCall) => ({
  userId,
  expand,
  limit,
  offset,
  orderBy,
  query,
  state,
  withCroppedPhotos,
  withHidden,
  withPhotos,
  minPrice,
  maxPrice,
  currency,
  from,
  to,
}: Query) =>
  makeCall<{
    count: number;
    listings: Listing[];
  }>('GET', `/api/v2/listings`, {
    query: {
      userId,
      expand,
      limit,
      offset,
      orderBy,
      query,
      state,
      withCroppedPhotos,
      withHidden,
      withPhotos,
      minPrice,
      maxPrice,
      currency,
      from,
      to,
    },
  });
